import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import {
	updateAbastecimentosList,
	updateCargasList,
	updateFreteirosList,
} from "../../redux/slicers/user";
import SearchableSelect from "../common/SearchableSelect";
import {
	cpf_mask,
	createFreteiro,
	getAllData,
	numerosDecimal,
	updateTable,
	verificaTipoUsuario,
} from "../../services/Servicos";
import Loading from "../loading/Loading";

import "./Modal.scss";
import ModalError from "./ModalError";
import { getErrorMessage, telefoneMask } from "../../services/helpers";
import ModalErrorPretty from "./ModalErrorPretty";

export default function ModalCriarFreteiro(props) {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.userSlice);
	const filiaisList = user.filiaisList.data;
	const transportadorasList = user.transportadorasList?.data || [];


	const [loading, setLoading] = useState({
		isLoading: false,
		msg: "Salvar",
		style: "primary",
	});

	const [body, setBody] = useState({
		responsavel: user.name,
		id_filial: user.tipo == "empresa" ? 2 : user.id_filial,
	});
	const [error, setError] = useState({
		show: false,
	});

	const handlerSimpleClose = () =>
		props.setShow((last) => ({ ...last, flag: false }));

	const submitDataEdit = () => {
		if (!body.placa) {
			setError({
				show: true,
				message: "Não é possível criar caminhão de Frete sem Placa.",
			});
			return;
		}
		if (!body.motorista_cpf) {
			
			setError({
				show: true,
				message: "Não é possível criar Freteiro sem o CPF do Motorista.",
			});
			return;
		}
		if (!body.motorista_nome) {
			
			setError({
				show: true,
				message: "Não é possível criar Freteiro sem o NOME do Motorista.",
			});
			return;
		}
		if (!body.transportadora) {
			
			setError({
				show: true,
				message: "Não é possível criar Freteiro sem o NOME da TRANSPORTADORA.",
			});
			return;
		}
		if (body.email && !body.email.includes(".frete@fermat.com")) {
			
			setError({
				show: true,
				children: <p>O email de acesso deve possuir <i><b>.frete@fermat.com</b></i></p>,
			});
			return;
		}

		setLoading({
			isLoading: true,
			msg: "Salvando",
			style: "warning",
		});
		let fBody = {};

		Object.keys(body).forEach((e) => {
			if (e == "capacidade" || e == "tara" || e == "pbt") {
				fBody[e] = body[e].replace(",", ".");
				return;
			}
			fBody[e] = body[e];
		});

		createFreteiro(fBody, user.tipo)
			.then((response) => {
				setLoading({
					isLoading: false,
					msg: "Enviado",
					style: "success",
				});
				setTimeout(() => {
					updateFreteiroListArray();
				}, 700);
			})
			.catch((error) => {
				if (error.response?.data?.errors) {
					setError({
						show: true,
						message: "Freteiro já Cadastrado Anteriormente",
					});
				} else {
					setError({
						show: true,
						message: getErrorMessage(error.response),
					});
				}
				setLoading({
					isLoading: false,
					msg: "Error",
					style: "danger",
				});

				setTimeout(() => {
					setLoading({
						isLoading: false,
						msg: "Enviar",
						style: "primary",
					});
				}, 1000);
			});
	};

	const onChangeInput = (e) => {
		if (
			e.target.name === "capacidade" ||
			e.target.name === "tara" ||
			e.target.name === "pbt"
		) {
			setBody((last) => ({
				...last,
				[e.target.name]: numerosDecimal(e.target.value.replace(/\D/g, "")),
			}));
			return;
		}
		if (e.target.name === "motorista_cpf") {
			setBody((last) => ({
				...last,
				[e.target.name]: cpf_mask(e.target.value),
			}));
			return;
		}
		if (e.target.name === "motorista_telefone") {
			setBody((last) => ({
				...last,
				[e.target.name]: telefoneMask(e.target.value),
			}));
			return;
		}
		if (e.target.name === "email") {
			if(e.target.value.includes('.frete@fermat.com')){
				setValidaEmail(false)
			}else{
				setValidaEmail(true)
			}
			setBody((last) => ({
				...last,
				[e.target.name]: e.target.value,
			}));
			return;
		}
		if (e.target.name === "transportadora") {
			setBody((last) => ({
				...last,
				[e.target.name]: e.target.value,
			}));
			return;
		}
		setBody((last) => ({
			...last,
			[e.target.name]: e.target.value.toUpperCase(),
		}));
	};

	const updateFreteiroListArray = () => {
		getAllData("caminhoes/freteiro")
			.then((response) => {
				dispatch(updateFreteirosList(response.data));
				handlerSimpleClose();
			})
			.catch((err) => {
			
				setError({
					show: true,
					message: getErrorMessage(err),
				});
			})
			.finally(() => {
				setLoading({
					isLoading: false,
					msg: "Enviar",
					style: "primary",
				});
			});
	};

	const [validaEmail, setValidaEmail] = useState(true)
	return (
		<>
			<Modal
				show={props.show}
				onHide={handlerSimpleClose}
				backdrop="static"
				keyboard={false}
				centered
				size="md"
			>
				<Modal.Header closeButton>
					<Modal.Title>{props.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form
						onSubmit={(e) => {
							e.preventDefault();
							submitDataEdit();
						}}
					>
						
						<h4>Dados cadastrais</h4>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Tipo de Caminhão:</Form.Label>
							</Col>
							<Col>
								<Form.Select type="text" name="tipo" onChange={onChangeInput}>
									<option value=""></option>
									<option value="Toco">Toco</option>
									<option value="Truck">Truck</option>
									<option value="BiTruck">BiTruck</option>
									<option value="Carreta">Carreta</option>
								</Form.Select>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Placa:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="placa"
									onChange={onChangeInput}
									maxLength={8}
									value={body.placa}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Capacidade:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="capacidade"
									onChange={onChangeInput}
									value={body.capacidade}
									maxLength={5}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>PBT:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="pbt"
									onChange={onChangeInput}
									value={body.pbt}
									maxLength={5}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>TARA:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="tara"
									onChange={onChangeInput}
									value={body.tara}
									maxLength={5}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>CPF do Motorista:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="motorista_cpf"
									onChange={onChangeInput}
									value={body.motorista_cpf}
									maxLength={14}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Nome do Motorista:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="motorista_nome"
									onChange={onChangeInput}
									value={body.motorista_nome}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Telefone do Motorista:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="motorista_telefone"
									onChange={onChangeInput}
									value={body.motorista_telefone}
									maxLength={15}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Transportadora:</Form.Label>
							</Col>
							<Col>
								<SearchableSelect
									options={transportadorasList}
									value={body.transportadora}
									onChange={onChangeInput}
									name="transportadora"
									placeholder="Selecione uma transportadora..."
									searchPlaceholder="Buscar transportadora..."
									getOptionValue={(option) => option.cnpj || option}
									getOptionLabel={(option) => option.nome_fantasia || option.razao_social || option}
									renderOption={(option) => option.nome_fantasia || option.razao_social || option}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Email pessoal:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="email_pessoal"
									onChange={onChangeInput}
									value={body.email_pessoal}
								/>
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Propriedade:</Form.Label>
							</Col>
							<Col>
								<Form.Select
									onChange={onChangeInput}
									defaultValue={body.id_filial}
									disabled={user.tipo !== "empresa" || user.id_filial == 2}
								>
									<option value={0}></option>
									{filiaisList.map((item, index) => (
										<option key={index} value={item.idFilial}>
											{item.identificacaoInterna}
										</option>
									))}
								</Form.Select>
							</Col>
						</Row>
						<hr/>
						<h4>Acesso ao aplicativo</h4>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Email:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="email"
									name="email"
									placeholder="Email deve ter '.frete@fermat.com'"
									onChange={onChangeInput}
									value={body.email}
								/>
								{validaEmail ? <div className="text-danger">O email de acesso deve possuir <i style={{fontSize: 'inherit', fontWeight: 'bold'}}>.frete@fermat.com</i></div>: ''}
							</Col>
						</Row>
						<Row className="mb-2">
							<Col sm="4">
								<Form.Label>Senha:</Form.Label>
							</Col>
							<Col>
								<Form.Control
									type="text"
									name="password"
									placeholder="Digite a senha do motorista..."
									onChange={onChangeInput}
									value={body.senha}
								/>
							</Col>
						</Row>
						<button type="submit" hidden></button>
					</Form>
				</Modal.Body>
				<Modal.Footer>
					<Row style={{ width: "100%" }}>
						<Col>
							<Button
								type="submit"
								variant={loading.style}
								onClick={submitDataEdit}
								disabled={loading.style == "primary" ? false : true}
							>
								{loading.isLoading ? (
									<Loading msg={loading.msg} />
								) : (
									loading.msg
								)}
								{loading.style == "success" ? (
									<i className="bi bi-check"></i>
								) : (
									""
								)}
							</Button>
						</Col>
						<Col>
							<Button variant="secondary" onClick={handlerSimpleClose}>
								Cancelar
							</Button>
						</Col>
					</Row>
				</Modal.Footer>
				{error.show ? (
					<ModalErrorPretty
						setShow={setError}
						{...error}
					/>
				) : (
					""
				)}
			</Modal>
		</>
	);
}
